import "../../assets/scss/app.scss";

import AroundSwiper from "./class/Swiper";
import AroundSection from "./class/aroundSection";
class Main {
  constructor() {
    this.init();
  }

  init() {
    new AroundSwiper();
    new AroundSection();
  }
}
window.addEventListener("DOMContentLoaded", () => {
  new Main();
});

//googlefont読み込み
var WebFont = require("webfontloader");
WebFont.load({
  google: {
    families: ["Heebo:300,400,500", "Material Icons"],
  },
});

!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 360
        ? "width=device-width,initial-scale=1"
        : "width=360";
    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }
  addEventListener("resize", switchViewport, false);
  switchViewport();
})();

//スムーススクロール
import SmoothScroll from "smooth-scroll";
new SmoothScroll('a[href*="#"]', {
  header: "[data-scroll-header]",
  speed: 100,
});

//スライダー
import Swiper from "swiper/bundle";

var experience_slider = new Swiper(".js-experience-archive__slider", {
  spaceBetween: 2,
  loop: true,
  slidesPerView: 1.1451612903,
  navigation: {
    prevEl: ".c-archive__slider--button-prev",
    nextEl: ".c-archive__slider--button-next",
  },
  pagination: {
    el: ".c-archive__slider--pagination",
    clickable: true,
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
    },
  },
});

var index_mv_slider = new Swiper(".index-mv__slider--container", {
  spaceBetween: 1,
  loop: true,
  slidesPerView: 2,
  speed: 50000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    769: {
      speed: 100000,
    },
  },
});

var index_itineraries_slider = new Swiper(
  ".index-itineraries__slider--container",
  {
    loop: true,
    loopAdditionalSlides: 1,
    spaceBetween: 20,
    breakpoints: {
      769: {
        spaceBetween: 0,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  }
);

var index_seasons_slider = new Swiper(".c-season__slider--container", {
  loop: true,
  loopAdditionalSlides: 1,
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    769: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var itineraryCourse_seasons_slider = new Swiper(
  ".itineraryCourse__slider--container",
  {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      769: {
        slidesPerView: 2,
        spaceBetween: 0,
        loop: false,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  }
);

var index_media_slider = new Swiper(".js-index-archive__slider", {
  loop: true,
  spaceBetween: 2,
  slidesPerView: 1.1355932203,
  navigation: {
    prevEl: ".c-archive__slider--button-prev",
    nextEl: ".c-archive__slider--button-next",
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
    },
  },
});

var news_slider = new Swiper(".js-media-archive__slider", {
  loop: true,
  spaceBetween: 2,
  slidesPerView: 1.1355932203,
  navigation: {
    prevEl: ".c-archive__slider--button-prev",
    nextEl: ".c-archive__slider--button-next",
  },
  breakpoints: {
    769: {
      loop: false,
      slidesPerView: 2,
    },
  },
});

let lock = false;
let scrollpos;
let navBtn = document.getElementById("navBtn");
let navBox = document.getElementById("navBox");
if (navBtn) {
  navBtn.addEventListener(
    "click",
    function () {
      navBtn.classList.toggle("-open");
      navBox.classList.toggle("-open");
      if (lock == false) {
        scrollpos = document.documentElement.scrollTop;
        document.body.classList.add("fixed");
        document.body.style.top = scrollpos;
        lock = true;
      } else {
        document.body.classList.remove("fixed");
        document.body.style.top = "0";
        document.documentElement.scrollTo(0, scrollpos);
        lock = false;
      }
    },
    false
  );
}

window.addEventListener("scroll", function () {
  if (window.scrollY > 0) {
    document.querySelector(".h-menu").classList.remove("-top");
  } else {
    document.querySelector(".h-menu").classList.add("-top");
  }
});

function mapHover() {
  const arr = [
    "hokkaido",
    "tohoku",
    "greatertokyo",
    "centraljapan",
    "kansai",
    "sanin",
    "setouchi",
    "shikoku",
    "kyushu",
    "okinawa",
  ];

  arr.forEach(function (elem, index) {
    const headerIcon_trigger = ".area--" + elem;
    const headerIcon = document.querySelectorAll(headerIcon_trigger);
    const target = map.querySelectorAll(".area");

    for (let i = 0; i < headerIcon.length; i++) {
      headerIcon[i].addEventListener("mouseover", () => {
        if (!around.classList.contains("-" + elem)) {
          map.classList.add("-" + elem);
          nav_map.classList.add("-" + elem);
        }
      });
      headerIcon[i].addEventListener("mouseleave", () => {
        const current = document.querySelector("div.wrapper");
        const currentName = current.id;

        map.classList.remove("-" + elem);
        if (currentName != elem) {
          nav_map.classList.remove("-" + elem);
        }
      });
    }
  });
}
mapHover();

function mapCurrent() {
  const current = document.querySelector("div.wrapper");
  const navMap = document.getElementById("nav_map");
  const currentName = current.id;
  navMap.classList.add("-" + currentName);
}
mapCurrent();

(function () {
  // DOM-Elementを取得しておく
  const cookieConsent = document.querySelector(".l-cookie");
  const cookieAgree = document.querySelector(".l-cookie__accept");

  // Cookieを拒否した時用のFlag
  const rejectFlag = sessionStorage.getItem("rejectFlag");
  // console.log({ rejectFlag });

  const cookieData = document.cookie;
  // console.log({ cookieData });

  // CookieをSetしているかどうかを判定するためのFlag
  let cookieSetFlag = false;

  // 綺麗に分割するために「'; '」(セミコロン&半角スペース)で区切る！
  const cookieDataList = cookieData.split("; ");
  // console.log({ cookieDataList });

  for (const cookie of cookieDataList) {
    const cookieSplit = cookie.split("=");
    // console.log({ cookieSplit });

    if (cookieSplit[0] === "robotama-cookie") cookieSetFlag = true;
    // console.log({ cookieSetFlag });
  }

  // Cookieの有効期限（日）をSetする
  const expire = 31;

  // 1. Yes Cookie-Set-Function => 引数は有効期限(日)
  function SetCookie(expire) {
    const current = new Date();
    expire = current.getTime() + expire * 24 * 3600 * 1000;

    // CookieにDataをSetする
    document.cookie = `robotama-cookie=robotama-read; expire=${expire}`;
  }

  // 2. Cookieを拒否したときに、Cookieをすべて削除するFunction
  function DeleteAllCookie() {
    const maxAgeZero = "max-age=0";

    for (const cookie of cookieDataList) {
      const cookieSplit = cookie.split("=");

      document.cookie = `${cookieSplit[0]}=; ${maxAgeZero}`;
    }
  }

  // 3. Popup表示のFunction
  function PopupDisplay() {
    if (cookieConsent !== null) {
      cookieConsent.classList.add("is-show");
    }
  }

  if (cookieSetFlag) {
    // console.log("cookieSetFlagが立っている！Cookie同意済みUser");
  } else {
    if (rejectFlag) {
      // console.log("rejectFlagが立っている！Cookie-拒否User");
    } else {
      // console.log("2つのFlagが立っていない！初回Access-Userか、有効期限切れUser");
      PopupDisplay();
    }
  }

  // Cookie同意ボタンにイベントを追加する;
  if (cookieAgree !== null) {
    cookieAgree.addEventListener("click", () => {
      cookieConsent.classList.add("is-hide");
      SetCookie(expire);
    });
  }
})();
